import { RichTextBox } from './RichTextBox';

export const StandaloneRichTextBox: typeof RichTextBox = (props) => <RichTextBox {...props} />;
